import _ from 'lodash';
import positionUtil from './position';
var getViewportSize = positionUtil.getViewportSize,
  getMaxAllowedBottom = positionUtil.getMaxAllowedBottom,
  getMaxAllowedRight = positionUtil.getMaxAllowedRight,
  getRectMiddle = positionUtil.getRectMiddle;
export var CONSTS = {
  INDENT_FROM_EDGE: 12,
  TOOLTIP_PADDING: 6,
  ALIGNMENT: {
    TOP: 'TOP',
    LEFT: 'LEFT',
    BOTTOM: 'BOTTOM',
    RIGHT: 'RIGHT'
  }
};
var isVerticalAlignment = function isVerticalAlignment(params) {
  return params.alignment === CONSTS.ALIGNMENT.TOP || params.alignment === CONSTS.ALIGNMENT.BOTTOM;
};
function getVRange(viewport, triggerRect, contentRect) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  params.alignment = params.alignment || CONSTS.ALIGNMENT.TOP;
  var triggerRectBottom = triggerRect.y + triggerRect.height;
  if (isVerticalAlignment(params)) {
    var min = triggerRect.y - contentRect.height - CONSTS.TOOLTIP_PADDING;
    var max = triggerRectBottom + contentRect.height + CONSTS.TOOLTIP_PADDING;
    var canFit = {
      top: min > CONSTS.INDENT_FROM_EDGE,
      bottom: max < getMaxAllowedBottom(viewport)
    };
    var vRangeTop = {
      min: min,
      max: triggerRect.y - CONSTS.TOOLTIP_PADDING
    };
    var vRangeBottom = {
      min: triggerRectBottom + CONSTS.TOOLTIP_PADDING,
      max: max
    };
    if (params.alignment === CONSTS.ALIGNMENT.TOP) {
      return canFit.bottom && !canFit.top ? vRangeBottom : vRangeTop;
    }
    return !canFit.bottom && canFit.top ? vRangeTop : vRangeBottom;
  }

  // TODO: Adjust to viewport
  var anchor = triggerRect.y + triggerRect.height / 2;
  var isAbsolute = params.arrowDistance && params.arrowDistance < contentRect.height;
  var firstContentPart = isAbsolute ? params.arrowDistance : contentRect.height / 2;
  var lastContentPart = contentRect.height - firstContentPart;
  return {
    min: anchor - firstContentPart,
    max: anchor + lastContentPart
  };
}
function getHRange(viewport, triggerRect, contentRect) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // TODO: Remove code duplication
  params.alignment = params.alignment || CONSTS.ALIGNMENT.TOP;
  var triggerRectRight = triggerRect.x + triggerRect.width;
  if (!isVerticalAlignment(params)) {
    var min = triggerRect.x - contentRect.width - CONSTS.TOOLTIP_PADDING;
    var max = triggerRectRight + contentRect.width + CONSTS.TOOLTIP_PADDING;
    var canFit = {
      left: min > CONSTS.INDENT_FROM_EDGE,
      right: max < getMaxAllowedRight(viewport)
    };
    var vRangeLeft = {
      min: min,
      max: triggerRect.x - CONSTS.TOOLTIP_PADDING
    };
    var vRangeRight = {
      min: triggerRectRight + CONSTS.TOOLTIP_PADDING,
      max: max
    };
    if (params.alignment === CONSTS.ALIGNMENT.LEFT) {
      return canFit.right && !canFit.left ? vRangeRight : vRangeLeft;
    }
    return !canFit.right && canFit.left ? vRangeLeft : vRangeRight;
  }

  // TODO: Adjust to viewport
  var anchor = triggerRect.x + triggerRect.width / 2;
  var isAbsolute = params.arrowDistance && params.arrowDistance < contentRect.width;
  var firstContentPart = isAbsolute ? params.arrowDistance : contentRect.width / 2;
  var lastContentPart = contentRect.width - firstContentPart;
  return {
    min: anchor - firstContentPart,
    max: anchor + lastContentPart
  };
}
function getContentPosition(viewport, triggerRect, contentRect) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // eslint-disable-line no-unused-vars
  var hRange = getHRange.apply(void 0, arguments);
  var vRange = getVRange.apply(void 0, arguments);
  var optionsPosition = {
    x: hRange.min,
    width: hRange.max - hRange.min,
    y: vRange.min,
    height: vRange.max - vRange.min
  };
  return _.mapValues(optionsPosition, Math.ceil);
}

// TODO: Refactor + naming
var getFinalPositions = function getFinalPositions(viewport, triggerRect, contentPosition) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var contentBottom = contentPosition.y + contentPosition.height;
  var contentRight = contentPosition.x + contentPosition.width;
  params.alignment = params.alignment || CONSTS.ALIGNMENT.TOP;
  var arrow;
  if (isVerticalAlignment(params)) {
    arrow = {
      x: getRectMiddle(triggerRect).x,
      y: triggerRect.y > contentPosition.y ? contentBottom : contentPosition.y
    };
    var maxAllowedRight = getMaxAllowedRight(viewport);
    var x = contentPosition.x;
    if (maxAllowedRight < contentRight) {
      x -= contentRight - maxAllowedRight;
    } else if (CONSTS.INDENT_FROM_EDGE > contentPosition.x) {
      x += CONSTS.INDENT_FROM_EDGE - contentPosition.x;
    }
    return {
      content: _.assign({}, contentPosition, {
        x: x
      }),
      arrow: arrow
    };
  }
  // TODO: Remove code duplication
  arrow = {
    x: triggerRect.x > contentPosition.x ? contentRight : contentPosition.x,
    y: getRectMiddle(triggerRect).y
  };
  var maxAllowedBottom = getMaxAllowedBottom(viewport);
  var y = contentPosition.y;
  if (maxAllowedBottom < contentBottom) {
    y -= contentBottom - maxAllowedBottom;
  } else if (CONSTS.INDENT_FROM_EDGE > contentPosition.y) {
    y += CONSTS.INDENT_FROM_EDGE - contentPosition.y;
  }
  return {
    content: _.assign({}, contentPosition, {
      y: y
    }),
    arrow: arrow
  };
};
export default {
  getViewportSize: getViewportSize,
  getContentPosition: getContentPosition,
  getFinalPositions: getFinalPositions,
  isVerticalAlignment: isVerticalAlignment,
  CONSTS: CONSTS
};